import { render } from "./box.vue?vue&type=template&id=06ca822d&scoped=true"
import script from "./box.vue?vue&type=script&lang=js"
export * from "./box.vue?vue&type=script&lang=js"

import "./box.vue?vue&type=style&index=0&id=06ca822d&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ca822d"]])

export default __exports__